var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-footer',{attrs:{"absolute":"","color":"#222"}},[_c('v-spacer'),_c('div',{staticClass:"font-weight-medium text-white"},[_vm._v("© Reactome "+_vm._s(new Date().getFullYear()))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }